// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ka-0";